export const TOKEN_LOCAL_STORAGE = "TOKEN_LOCAL_STORAGE_ANHPT";
export const USER_ID_LOCAL_STORAGE = "USER_ID_LOCAL_STORAGE_ANHPT";
